import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import Util from 'utility';
import api from 'api';
import { __ } from 'locale';
import { setTags, showMessage } from 'actions/index';

const recipeTagsGroupCls = 'flex flex-wrap [&>input[type=checkbox]]:hidden [&>label]:inline-flex [&>label]:items-center [&>label]:cursor-pointer [&>label]:py-[0.35em] [&>label]:px-[0.5em] [&>label]:rounded [&>label]:bg-[#e9f5e5] [&>label]:mr-[4px] [&>label]:mb-[4px] [&>label]:whitespace-nowrap [&>label>span]:inline-flex [&>label>span]:items-center [&>label>span]:justify-center [&>label>span]:w-[1.5em] [&>label>span]:h-[1.5em] [&>label>span]:border [&>label>span]:border-[#26AA52] [&>label>span]:rounded [&>label>span]:mr-[0.5em] [&>label>span]:text-[0.85em] [&>label>span]:bg-white [&>label>span>i]:text-white [&>input:checked+label]:bg-[#26AA52] [&>input:checked+label]:text-white [&>input:checked+label>span>i]:text-[#26AA52]';
const saveRowNewCls = 'flex my-[4px] mb-[0.5em] pr-[16px] [&>input]:flex-1 [&>input]:font-bold [&>input]:py-[0.5em] [&>input]:px-[1em] [&>input]:bg-[#ffd] [&>input]:border [&>input]:border-[#999] [&>button]:font-bold [&>button]:ml-[1em] [&>button]:w-[9rem] [&>button]:text-[0.85em] [&>button]:cursor-pointer [&>button]:bg-[#26AA52] [&>button]:text-white [&>button]:border-none [&:hover>button]:bg-[#2dcb62]';
const saveRowExistingCls = 'flex my-[4px] pr-[16px] text-[0.9em] hover:bg-[#ff6] [&>span]:flex-1 [&>span]:block [&>span]:py-[0.25em] [&>span]:px-[0.5em] [&>button]:ml-[1em] [&>button]:w-[9rem] [&>button]:text-[0.85em] [&>button]:cursor-pointer [&>button]:bg-[#888] [&>button]:text-white [&>button]:border-none [&:hover>button]:bg-[#555]';

function LectureTaskPanelSave({ mealHash, mealId, currentRecipeId, onSaved }) {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const { globals } = data;

    const getInitialRecipeName = () => {
        const name = data.titles['1|0'];
        return typeof name === 'string' ? name : '';
    };

    const getInitialTags = () => {
        return typeof data.tags[mealHash] !== 'undefined' ? data.tags[mealHash] : [];
    };

    const [recipeName, setRecipeName] = useState(getInitialRecipeName);
    const [savedRecipes, setSavedRecipes] = useState({});
    const [tags, setTagsState] = useState(getInitialTags);
    const [useInGenerator, setUseInGenerator] = useState(false);

    const recipeNameInputRef = useRef(null);

    useEffect(() => {
        api('recipes/list-saved').then(result => {
            setSavedRecipes(result.data);
        });
    }, []);

    const handleTagChange = (e) => {
        const v = parseInt(e.target.value);
        const newTags = tags.includes(v) ? tags.filter(item => item !== v) : [...tags, v];
        setTagsState(newTags);
        dispatch(setTags(newTags));
    };

    const doSaveRecipe = (e, overwriteId) => {
        const id = overwriteId !== undefined ? overwriteId : (e.target.attributes.getNamedItem('data-id').value * 1);

        if (overwriteId === undefined && id === 0) {
            if (recipeName.trim() === '') {
                recipeNameInputRef.current?.focus();
                dispatch(showMessage({ show: true, type: 'error', message: 'Zadejte název receptu.' }));
                return false;
            }
        }

        const effectiveRecipeName = overwriteId !== undefined ? (savedRecipes[overwriteId] || recipeName) : recipeName;

        const gastroData = typeof data.gastro === 'object' ? data.gastro : { ingredients_origin: '', grammage: '', price: '' };

        const saveData = JSON.stringify({
            activeMealHash: JSON.stringify(mealHash),
            titles: JSON.stringify(data.titles),
            recipeName: effectiveRecipeName,
            foods: JSON.stringify(data.foods),
            groups: JSON.stringify(data.foodGroups),
            modifications: JSON.stringify(data.modifications),
            descriptions: JSON.stringify(data.descriptions),
            tags: JSON.stringify(tags),
            useInGenerator,
            cookBookRecipeId: data.lastOpenedCookBookRecipe,
            gastro: JSON.stringify(gastroData),
            id
        });

        api('save/recipe2', { post: true, data: saveData }).then(result => {
            if (result.data.ok === 1) {
                localStorage.removeItem('zof_unsaved_recipe');
                dispatch(showMessage({ show: true, type: 'success', message: 'Recept byl uložen.' }));
                onSaved();
            }
        });
    };

    const tagItems = [];
    Object.values(globals.tagGroupsOrder || {}).forEach(g => {
        const tg = (globals.tagGroups || {})[g];
        const groupContents = Object.keys((globals.tagsToGroups || {})[g] || {}).map(io => {
            const tagId = globals.tagsToGroups[g][io];
            return (
                <React.Fragment key={tagId}>
                    <input id={`rtag_${g}_${io}`} type="checkbox" defaultChecked={tags.includes(tagId)} onChange={handleTagChange} name="t" value={tagId} />
                    <label htmlFor={`rtag_${g}_${io}`}>
                        <span><i className="fa fa-check"></i></span>
                        {globals.tags[tagId]}
                    </label>
                </React.Fragment>
            );
        });
        tagItems.push(<h4 key={`h_${g}`}>{tg}</h4>);
        tagItems.push(<div key={`g_${g}`} className={recipeTagsGroupCls}>{groupContents}</div>);
    });

    let text1 = 'Použít tento recept v generátoru';
    let text2 = 'Před zařazením receptu do generátoru je důležité zaškrtnout všechny relevantní a správné štítky.';
    let text3 = 'Použít recept v generátoru jídelníčků';
    if(Util.getLang() === 'sk') {
        text1 = 'Použiť tento recept v generátore';
        text2 = 'Pred zaradením receptu do generátora je dôležité zaškrtnúť všetky relevantné a správne štítky.';
        text3 = 'Použiť recept v generátore jedálničkov';
    }

    const useRecipeInGeneratorOption = Util.userHasPurchased('ZOF_PROFI') ? (
        <div style={{ padding: '2em 0 1em 0' }}>
            <p><b>{text1}</b><br />
            {text2}</p>
            <label><input type="checkbox" name="use_in_generator" onChange={e => setUseInGenerator(e.target.checked ? 1 : 0)} checked={useInGenerator === 1} /> {text3}</label>
        </div>
    ) : null;

    const savedRecipesList = [];
    for (const r in savedRecipes) {
        if (r == currentRecipeId) {
            savedRecipesList.push(
                <div className={saveRowExistingCls} key={r}>
                    <span>{savedRecipes[r]}</span>
                    <button onClick={(e) => doSaveRecipe(e, r)}>Přepsat stávající recept</button>
                </div>
            );
        }
    }
    for (const r in savedRecipes) {
        if (r == currentRecipeId) continue;
        savedRecipesList.push(
            <div className={saveRowExistingCls} key={r}>
                <span>{savedRecipes[r]}</span>
                <button onClick={(e) => doSaveRecipe(e, r)}>{__('Přepsat recept')}</button>
            </div>
        );
    }

    return (
        <div className="flex flex-1 flex-col overflow-hidden">
            <div className="flex flex-1 ml-[-1em]">
                <div className="ml-[1em] flex basis-[440px]">
                    <Scrollbars heightrelativetoparent="1">
                        <div>{tagItems}</div>
                        {useRecipeInGeneratorOption}
                    </Scrollbars>
                </div>
                <div className="ml-[2em] flex flex-1">
                    <div className="flex-1">
                        <Scrollbars heightrelativetoparent="1">
                            <div className={saveRowNewCls}>
                                <input ref={recipeNameInputRef} onChange={e => setRecipeName(e.target.value)} value={recipeName} autoComplete="off" type="text" name="recipe_name" placeholder={__('Název ukládaného receptu')} />
                                <button data-id="0" type="button" onClick={doSaveRecipe}>{__('Uložit nový recept')}</button>
                            </div>
                            {savedRecipesList}
                        </Scrollbars>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LectureTaskPanelSave;
